/**
 * Checks whether a value looks like a machine-readable response code (e.g. `BOLT-ME-404-001`) rather than a prose message.
 * Used to keep prose out of the Sentry `errorCode` tag, since the backend puts codes in `message` for most endpoints.
 * @param {string} [value]
 * @returns {boolean}
 */
export const isResponseCode = (value?: string): boolean => !!value && value.length <= 64 && /^[A-Z0-9][A-Z0-9_-]*$/.test(value)
